<template>
  <div class="scroll-both-side-table">
    <div
      class="scroll-both-side-table_wrapper"
      @mouseover="$_scrollTable()"
      @mouseout="$_disableScrollTable()"
    >
      <table
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="100%"
        class="scroll-both-side-table_scroll-table"
      >
        <thead class="scroll-both-side-table_scroll-table-header">
          <tr>
            <th
              v-for="(columnHeaderItem,columnHeaderIndex) in columnHeader"
              :key="columnHeaderIndex"
              class="scroll-both-side-table_header_item"
              :class="[{tabletHide:columnHeaderItem.tabletHide,mobileHide:columnHeaderItem.mobileHide,icon:columnHeaderItem.type==='icon','clickable':hasClickableHeader && columnHeaderItem.clickable},columnHeaderItem.align]"
              :style="{minWidth :`${columnHeaderItem.minWidth}px`}"
              @click="$_headerClick(columnHeaderIndex,columnHeaderItem.id)"
            >
              {{ columnHeaderItem.textLabel }}<span
                v-if="hasClickableHeader && columnHeaderItem.clickable"
                class="header-item_click-btn"
              >
                <i
                  class="icon-sort-arrow-up header-item_click-btn-icon"
                  :class="{active : ingClickHeaderIndex === columnHeaderIndex && ingClickHeaderSort === 'desc'}"
                /><i
                  class="icon-sort-arrow-down header-item_click-btn-icon"
                  :class="{active : ingClickHeaderIndex === columnHeaderIndex && ingClickHeaderSort === 'asc'}"
                /></span>
            </th>
          </tr>
        </thead>
        <tbody class="scroll-both-side-table_scroll-table-body">
          <tr
            v-for="(rowItem, rowItemIndex) in rowData"
            :key="rowItemIndex"
          >
            <td
              v-for="(columnHeaderItem,columnHeaderItemIndex) in columnHeader"
              :key="columnHeaderItemIndex"
              class="scroll-both-side-table_body_item"
              :class="columnHeaderItem.align"
              :style="{minWidth :`${columnHeaderItem.minWidth}px`}"
            >
              <div
                v-if="columnHeaderItem.type === 'text'"
                class="scroll-both-side-table_body_item-text"
                :class="[columnHeaderItem.fontSize]"
              >
                {{ rowItem[columnHeaderItem.id] }}
              </div>
              <div
                v-if="columnHeaderItem.type === 'number'"
                class="scroll-both-side-table_body_item-number"
                :class="[columnHeaderItem.fontSize,columnHeaderItem.textAlign]"
              >
                {{ rowItem[columnHeaderItem.id] }}<span
                  v-if="columnHeaderItem.unit"
                  class="scroll-both-side-table_body_item-number-unit"
                >{{ columnHeaderItem.unit }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "ScrollBothSideTable",
  props: {
    columnHeader: {
      type: Array,
      default() {
        return [];
      },
    },
    rowData: {
      type: Array,
      default() {
        return [];
      },
    },
    hasClickableHeader: {
      type: Boolean,
      default: false,
    },
    ingClickHeaderIndex: {
      type: Number,
      default: 0,
    },
    ingClickHeaderSort: {
      type: String,
      default: "",
    },
  },
  methods: {
    $_scrollTable() {
      this.$emit("scroll-table");
    },
    $_disableScrollTable() {
      this.$emit("disable-scroll");
    },
    $_headerClick(headerIndex, headerItemId) {
      let sortBy = "";
      let sortWay = "";
      let index = -1;
      if (this.ingClickHeaderIndex !== headerIndex) {
        sortBy = headerItemId;
        sortWay = "desc";
        index = headerIndex;
      } else if (this.ingClickHeaderIndex > -1) {
        if (!this.ingClickHeaderSort) {
          sortBy = headerItemId;
          sortWay = "desc";
          index = headerIndex;
        } else if (this.ingClickHeaderSort === "desc") {
          sortBy = headerItemId;
          sortWay = "asc";
          index = headerIndex;
        } else {
          sortBy = "";
          sortWay = "";
          index = -1;
        }
      } else {
        sortWay = "desc";
        index = headerIndex;
      }
      this.$emit("header-click", {
        sortBy: sortBy,
        sortWay: sortWay,
        index: index,
      });
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/scroll-both-side-table";
</style>